"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getVisitorFunctions = void 0;
const binaryExpression_1 = require("./nodes/binaryExpression");
const cell_1 = require("./nodes/cell");
const cellRange_1 = require("./nodes/cellRange");
const function_1 = require("./nodes/function");
const logical_1 = require("./nodes/logical");
const number_1 = require("./nodes/number");
const text_1 = require("./nodes/text");
const unaryExpression_1 = require("./nodes/unaryExpression");
// Helper method to wrap all node handlers with logged visitors and structure actions to match excel-formula-parser expectations
const createVisitor = ({ formulaNode, buildContext, visitorContext, }) => {
    return {
        enter: (node) => {
            visitorContext.enterNode(node, formulaNode.hasChildNodes);
        },
        exit: (node) => {
            const evaluatorFunction = formulaNode.getEvaluatorFunction({
                node,
                buildContext,
            });
            buildContext.functionStack.push({
                node,
                evaluatorFunction,
            });
            visitorContext.exitNode(node, formulaNode.hasChildNodes);
        },
    };
};
// Helper function for evaluateAST
// The functions are named explicitly in this format because the underlying library requires it
// This may change in the future if this library is replaced within this package
const getVisitorFunctions = ({ buildContext, visitorContext, }) => {
    const { enter: enterCell, exit: exitCell } = createVisitor({
        formulaNode: cell_1.cellNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterCellRange, exit: exitCellRange, } = createVisitor({
        formulaNode: cellRange_1.cellRangeNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterFunction, exit: exitFunction, } = createVisitor({
        formulaNode: function_1.functionNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterNumber, exit: exitNumber } = createVisitor({
        formulaNode: number_1.numberNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterText, exit: exitText } = createVisitor({
        formulaNode: text_1.textNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterLogical, exit: exitLogical } = createVisitor({
        formulaNode: logical_1.logicalNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterBinaryExpression, exit: exitBinaryExpression, } = createVisitor({
        formulaNode: binaryExpression_1.binaryExpressionNode,
        buildContext,
        visitorContext,
    });
    const { enter: enterUnaryExpression, exit: exitUnaryExpression, } = createVisitor({
        formulaNode: unaryExpression_1.unaryExpressionNode,
        buildContext,
        visitorContext,
    });
    return {
        enterCell,
        exitCell,
        enterCellRange,
        exitCellRange,
        enterFunction,
        exitFunction,
        enterNumber,
        exitNumber,
        enterText,
        exitText,
        enterLogical,
        exitLogical,
        enterBinaryExpression,
        exitBinaryExpression,
        enterUnaryExpression,
        exitUnaryExpression,
    };
};
exports.getVisitorFunctions = getVisitorFunctions;
//# sourceMappingURL=visitor.js.map